<script>
export default {
	inheritAttrs: false,
	props: {
		index: Number,
		data: Object,
	},
}
</script>

<template>
	<RecetaDigitalManager />
</template>

